/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { EXPLORE_ROOM } from "../RoomNameConstants";

const state = {
    ID: EXPLORE_ROOM,
    centerGraphCompare: {
        data: {},
        position: { scale: 1, rotation: { x: 0, y: 0, z: 0 } },
        workstation: "Select",
        timeRange: "Select",
        timeRangeChoiches: [
            "Yesterday",
            "Last 2 days",
            "Last 3 days",
            "Last 4 days",
            "Last 5 days",
        ],
        isRequested: false,
    },
};

export default state;
